import React from 'react';
import { Icon } from '@vectord/components';
import { useSelector } from 'react-redux';

import { blacklistedMenteeDetailSelector } from 'features/communicationManagement';
import PersonalisedMenteeEmailersAddConfirmButton from '../PersonalisedMenteeEmailersAddConfirmButton';
import PersonalisedMenteeEmailersConfirmDetailInfo from '../PersonalisedMenteeEmailersConfirmDetailInfo';
import SectionHeading from 'components/SectionHeading';
import styles from './PersonalisedMenteeEmailersAddConfirmModal.module.scss';

export default function PersonalisedMenteeEmailersAddConfirmModal() {
  const snoozeLearnerDetail = useSelector(blacklistedMenteeDetailSelector);

  return (
    <>
      <SectionHeading
        title={
          <div className={styles.header}>
            <Icon
              name="warning"
              className="m-r-xxs danger"
            />
            Are you sure you want to snooze the following:
          </div>
        }
      />
      <PersonalisedMenteeEmailersConfirmDetailInfo
        label="Learner Email:"
        detail={snoozeLearnerDetail.user_email}
      />
      <div className={styles.footer}>
        <PersonalisedMenteeEmailersAddConfirmButton />
      </div>
    </>
  );
}
